// Packages
import { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";
import toast, { Toaster } from "react-hot-toast";
// Components
import UserPanelSideBar from "../../../Common/UserPanelSideBar/UserPanelSideBar";
import EditProfile from "../../../Contents/EditProfile/EditProfile";
import Reports from "../../../Contents/Reports/Reports";
import Cart from "../../../Contents/Cart/Cart";
// Styles
import Styles from "./Styles/Panel.module.css";
// images
import menuImg from "../../../../Assets/Icons/menu-light.png";
// Context
import { AuthContext } from "../../../../Context/AuthContext";
import MobileUserPanelSideBar from "../../../Common/UserPanelSideBar/MobileUserPanelSideBar";
import { updateUser } from "../../../../Services/usersService";

const Panel = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { isLoggedIn, login } = useContext(AuthContext);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const history = useHistory();
  const [token, setToken] = useState();
  const [decodedToken, setDecodedToken] = useState();

  const handleEditProfile = () => {
    setShowEditProfile((prev) => !prev);
  };

  useEffect(() => {
    const updateUserToken = async () => {
      try {
        const { data } = await updateUser();
        login(data.token);
        setToken(data.token);
      } catch (ex) {
        console.log(ex);
        toast.error(ex.response.data.message);
      }
    };
    if (token) {
      setDecodedToken(jwt_decode(token));
    } else if (isLoggedIn) {
      updateUserToken();
      setToken(localStorage.getItem("token"));
    }
  }, [token, login, isLoggedIn]);

  if (!isLoggedIn) {
    return history.replace("/users/login");
  }

  return (
    <div className={Styles.container}>
      <div onClick={() => setShowMenu(true)} className={Styles.mobileMenu}>
        <img src={menuImg} alt="" />
      </div>
      {showMenu && (
        <>
          <div className={Styles.mobileMenuContainer}>
            <MobileUserPanelSideBar />
          </div>
          <div
            onClick={() => setShowMenu(false)}
            className={Styles.closeMobileMenu}
          ></div>
        </>
      )}
      <Toaster
        toastOptions={{
          duration: 2000,
          style: {
            background: "#363636",
            color: "#fff",
          },
        }}
      />
      {showEditProfile && history.location.pathname === "/users/panel" && (
        <EditProfile handleEditProfile={handleEditProfile} />
      )}
      {/* reports */}
      {history.location.pathname === "/users/panel" && (
        <Reports
          Styles={Styles}
          decodedToken={decodedToken}
          token={token}
          handleEditProfile={handleEditProfile}
        />
      )}
      {/* cart */}
      {history.location.pathname === "/users/panel/cart" && (
        <Cart
          isLoggedIn={isLoggedIn}
          Styles={Styles}
          decodedToken={decodedToken}
        />
      )}

      {/* sidebar */}
      <UserPanelSideBar />
    </div>
  );
};

export default Panel;
